import { z } from 'zod';
import { AmplitudeScheme } from './amplitude';
import { CasinoSettingsScheme } from './casinoSettings';
import { ProvidersLiveDataConfigScheme } from './providersLiveDataConfig';

/**
 * Scheme for OtherSettings.
 */
export const OtherSettingsScheme = z
  .object({
    amplitude: AmplitudeScheme,
    providersLiveDataConfig: ProvidersLiveDataConfigScheme,
    casinoSettings: CasinoSettingsScheme,
    gameImageAnimationDurationSeconds: z.number().default(5),
    prerender: z
      .object({
        isLazyLoadedDisabled: z.boolean().default(false)
      })
      .default({}),
    groups: z.record(z.array(z.string())).default({}),
    isGamesWagerInfoEnabled: z.boolean().default(false),
    casinoIframeAllowProviders: z.record(z.string()).default({}),
    casinoProvidersWithSleepModeBlocked: z.array(z.string()).default([]),
    isGoBackInhanced: z.boolean().default(false),
    casinoProvidersWithBackToLobbyOnly: z.array(z.string()).default([]),
    pathsAliases: z.record(z.string()).default({})
  })
  .passthrough()
  .default({});

export type OtherSettings = z.infer<typeof OtherSettingsScheme>;
